import React, { Component } from 'react'
import PropTypes from 'prop-types'

import font from './style.css'

export default class FontIcon extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired, /* nome do icone - nomes em style.css ou demo.html */
        circle: PropTypes.bool,
        size: PropTypes.number,
        color: PropTypes.string
    }

    static defaultProps = {
        circle: false
    }



    render() {
        return (
            <i className={`
                ${font['icon']}
                ${font['icon-'+this.props.name]}
                ${font[this.props.circle ? 'circle' : '']}
                `}
            style={{
                ...this.props.style,
                fontSize: this.props.size ? `${this.props.size}px` : '',
                color: this.props.color,
                borderColor: this.props.color,
            }} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/atoms/FontIcon/index.js